import React from "react";
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import Button from "../../../components/buttons/Button";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import { toast } from "react-toastify";
import FormikDropdown from "../../../components/inputFields/FormikDropDown";
import { pricesColorCoding } from "../../../constants/prices_colors_coding";
import { addNewHudPatientPackage, patchNewHudPatientPackage } from "../../../services/new_clinic/new_hud_patients";

const NewAddUpdatePackage = ({ patientId, onAddNewPackage, initialValues = null, packageTable = [] }) => {
    const lastPackage = packageTable?.[0] ?? null;
    const isLastPaid = lastPackage?.package_status === "Paid";
    const lastAmount = lastPackage?.amount ?? 0;
    const filteredColors = pricesColorCoding.filter((val) => val.amount >= lastAmount);

    const handleSubmit = async (values, { setSubmitting }) => {
        let filteredData = packageTable?.filter((val) => val.package_name === values.package_type);

        const filteredPackage = filteredData[0];
        const cutoffDate = new Date("2025-05-29");

        if (filteredData.length === 0 || new Date(filteredPackage.date) < cutoffDate || filteredData.length > 0 && new Date(filteredPackage.date) >= cutoffDate && filteredPackage.remaining_amount <= 0) {
            setSubmitting(true);
            try {
                const response = initialValues.package_id
                    ? await patchNewHudPatientPackage(patientId, initialValues.package_id, values)
                    : await addNewHudPatientPackage(patientId, values);

                if (response?.status === 201 || response?.status === 200) {
                    onAddNewPackage();
                    toast.success(initialValues ? "Package updated successfully" : "Package added successfully!");
                } else {
                    toast.error("Oops! Something went wrong, please try again.");
                }
            } catch (error) {
                let errors = error?.response?.data?.error || "Oops! Something went wrong, please try again.";
                toast.error(errors);
            } finally {
                setSubmitting(false);
            }
        } else if (filteredData.length > 0) {
            toast.warning(`Please collect remaining amount of ₹${filteredPackage.remaining_amount} for last package`);
        }
    };

    const validationSchema = Yup.object({
        package_type: Yup.string().required("Package is required"),
        package_status: Yup.string().required("Type is required"),
        amount: Yup.string().required("Amount is required"),
    });

    return (
        <>
            <div className="w-full flex-1">
                <StyledHeadingText text="Add New Package" />
                <Formik
                    initialValues={{
                        package_type: "FULL BODY",
                        package_status: isLastPaid ? "Paid" : "Paid",
                        // date: new Date().toISOString().split("T")[0],
                        amount: lastAmount > 0 ? lastAmount : 10000,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, setFieldValue, values }) => (
                        <Form className="space-y-2 my-4">
                            <div className="flex flex-col">
                                <FormikDropdown
                                    label="Package Type"
                                    name="package_type"
                                    placeholder="Select Package"
                                    required={true}
                                    options={[
                                        { label: "TPT", value: "TPT" },
                                        { label: "HPF", value: "HPF" },
                                        { label: "FULL BODY", value: "FULL BODY" },
                                        { label: "HAND", value: "HAND" },
                                        { label: "FEET", value: "FEET" },
                                    ]}
                                />
                                <FormikDropdown
                                    label="Package Status"
                                    name="package_status"
                                    placeholder="Select Type"
                                    required={true}
                                    disabled={isLastPaid}
                                    options={[
                                        { label: "Paid", value: "Paid" },
                                        { label: "FOC", value: "FOC" },
                                    ]}
                                    onChange={(value) => {
                                        if (value.value === "FOC") {
                                            setFieldValue("amount", 0);
                                        } else {
                                            setFieldValue("amount", "");
                                        }
                                    }}
                                />
                                {/* <InputField
                                    label="Date"
                                    name="date"
                                    type="date"
                                    placeholder="Select Date"
                                    required
                                /> */}
                                <FormikDropdown
                                    label="Package Color"
                                    name="amount"
                                    placeholder="Select Amount"
                                    required={true}
                                    disabled={values.package_status === "FOC"}
                                    options={filteredColors.map((val) => ({
                                        label: `${val.title} (${val.short_hand})`,
                                        value: val.amount,
                                    }))}
                                />
                                <Button
                                    type="submit"
                                    className="bg-primary text-white px-4 py-2 rounded max-w-32"
                                    disabled={isSubmitting}
                                >
                                    {initialValues.package_id ? isSubmitting ? "Updating..." : "Update" : isSubmitting ? "Adding..." : "Add"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div >
        </>
    );
};

export default NewAddUpdatePackage;
